const ColliderDB = [
    {
        colliderId:'bench_box_coll',
        displayCollider:'N',
    }
];

export default ColliderDB;
